import VueRouter from 'vue-router';
import routes from './routes';

function getRouter(vueInstance) {
  vueInstance.use(VueRouter);

  const router = new VueRouter({
    base: '/item-mitra',
    mode: 'history',
    routes,
  });

  return router;
}

export default getRouter;
